export const formatSparkResultForClipboard = (data: any) => {
  if (!Array.isArray(data)) return '';

  return data
    .map((section) => {
      const sectionTitle = section.type ? `[${section.type}]` : '';
      let content = '';

      if (Array.isArray(section.content)) {
        content = section.content
          .map((item: any) => {
            return `${Object.entries(item)
              .map(([key, value]) => {
                if (Array.isArray(value)) {
                  return `${key}:\n${value.map((v) => `  - ${v}`).join('\n')}`;
                }
                return `${key}: ${value}`;
              })
              .join('\n')}\n`;
          })
          .join('\n');
      }

      return `${sectionTitle}\n${content}`;
    })
    .join('\n\n');
};
